import type { Session } from '../stores/session'

export type AclAction = 'read' | 'write'

/** ACL resource that every signed-in user may open (legacy pseudo-module `always`). */
export const ALWAYS = 'always'

/**
 * Legacy `useAuth.iCan(module, mode)` (`authService.js:165-190`, wp/shell §4.11): every user type but Staff may do
 * everything, as may anyone on `always`; for a Staff member the first software whose `modules` holds the key decides,
 * and an unknown key is refused. Without a session nothing is allowed.
 */
export function canWith(session: Session | null, resource: string, action: AclAction = 'read'): boolean {
  if (!session) return false
  if (resource === ALWAYS) return true
  if (session.userType !== 'Staff') return true
  for (const software of Object.values(session.permissions ?? {})) {
    const module = software.modules?.[resource]
    if (module) return Boolean(module.acl?.[action])
  }
  return false
}
